import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { PageSection } from "src/components/layout/PageSection";
import { SectionAnchor } from "src/pages/Legal/TermsOfService";
import { colorCssVars } from "src/theme/color";
import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { spacing, verticalStackCss } from "src/theme/spacing";
import { FontWeight, TextCssVar, textSizeCss } from "src/theme/text";

const steps = [
  {
    title: "Find a cause you believe in.",
    description: `Search for your favorite charity, browse by cause area, or see where and why people give! Or make one crypto donation to fund your Every.org account balance, then support many different nonprofits.`,
  },
  {
    title: "Donate crypto in a few clicks.",
    description: `Click "Donate" to give Bitcoin, Ethereum, USD Coin and more. Automatically receive a tax receipt — donating appreciated assets can be much more tax efficient.`,
  },
  {
    title: "Zero hassle for nonprofits.",
    description: `Our exchanges instantly convert your crypto donation to USD a nonprofit can use. They charge a 1% fee and Every.org charges 0. We're a nonprofit that helps nonprofits!`,
  },
];

const StyledList = styled.ol`
  display: grid;
  grid-gap: ${spacing.xl};
  grid-template-columns: repeat(${steps.length}, 1fr);
  ${cssForMediaSize({
    max: MediaSize.MEDIUM,
    css: css`
      grid-template-columns: 1fr;
    `,
  })}
`;

const StyledListItem = styled.li`
  ${verticalStackCss.m};
  position: relative;
  padding-left: ${spacing.xxl};
  color: var(${colorCssVars.text.secondary});

  & > h3 {
    color: var(${colorCssVars.text.body});
    font-weight: ${FontWeight.REGULAR};
    ${textSizeCss.m};
  }

  & > p {
    ${textSizeCss.s}
  }
`;

export const StyledNumberItem = styled.div`
  position: absolute;
  left: 0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 1.5px solid rgba(134, 138, 138, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  ${textSizeCss.xxs}
`;

const Steps = () => (
  <StyledList>
    {steps.map(({ title, description }, index) => (
      <StyledListItem key={title}>
        <StyledNumberItem>
          <span>{index + 1}</span>
        </StyledNumberItem>
        <h3>{title}</h3>
        <p>{description}</p>
      </StyledListItem>
    ))}
  </StyledList>
);

export const StepsSection = () => (
  <PageSection>
    <SectionAnchor id="steps" />
    <div css={verticalStackCss.xxl}>
      <h2
        css={css`
          ${TextCssVar.SIZE}: 40px;
          ${TextCssVar.LINE_HEIGHT}: 48px;
          line-height: var(${TextCssVar.LINE_HEIGHT});
          font-size: var(${TextCssVar.SIZE});
          ${cssForMediaSize({ max: MediaSize.MEDIUM, css: textSizeCss.xl })}
          letter-spacing: -0.02em;
          span {
            color: var(${colorCssVars.accent.large});
          }
        `}
      >
        <span>Verified tax-deductible nonprofits</span> in one place.
      </h2>
      <Steps />
    </div>
  </PageSection>
);
